// @ts-strict-ignore
import {RetentionApiChartType, RetentionChartType} from 'common/report/retention/util/types';
import {ChartType as CommonChartType, RetentionType} from 'common/types/reports/bookmark';

export const AGGREGATED_ROW_NAME = (reportType: RetentionType) =>
  `Weighted Average ${reportType === `addiction` ? `Frequency` : `Value`}`;

export const AGGREGATED_ROW_NAME_TRANSLATABLE =
  (reportType: RetentionType) =>
  ({t}) =>
    reportType === `addiction`
      ? t(`chart-actions.frequency.weighted-average`)
      : t(`chart-actions.retention.weighted-average`);

// Map to/from bookmark format
// TODO: consider doing a pass changing API's to be consistent with our unique ChartType enums
export const COMMON_CHART_TYPE_TO_API_CHART_TYPE: {[key in RetentionChartType]: RetentionApiChartType} = {
  // Cast any old line chart bookmarks to table
  [CommonChartType.RetentionLine]: RetentionApiChartType.Table,
  [CommonChartType.RetentionTable]: RetentionApiChartType.Table,
  [CommonChartType.RetentionTrend]: RetentionApiChartType.RetentionTrend,
  [CommonChartType.RetentionTrendMetric]: RetentionApiChartType.RetentionTrendMetric,
};

export enum RetentionTrackingEvents {
  AddCustomRetentionBucket = `Add custom retention bucket`,
  ClickedAdvancedQuerySettings = `Clicked advanced query settings`,
  ClickedRetentionCriteria = `Clicked retention criteria`,
  ChangeChartType = `Changed chart type`,
  ChangePercentageView = `Changed percentage view`,
  ChangeCumulative = `Changed cumulative`,
  ChangeUnbounded = `Changed unbounded`,
  ChartLegendClick = `Clicked chart legend`,
  Cohortize = `Cohortize`,
  IntervalAlignment = `Interval alignment`,
  ScrolledTable = `Scrolled table`,
  SortedTable = `Sorted table`,
  PopoverSaveCohort = `[Viewed popover] Save cohort`,
  PopoverClickCreateCohort = `[Viewed popover] Create cohort button`,
  PopoverCancelCreateCohort = `[Viewed popover] Cancel cohort`,
  PopoverViewUsers = `[Viewed popover] View Users`,
  PopoverOpen = `[Viewed popover] Click on a chart/cell`,
  UnboundedMode = `Retention Unbounded Mode Toggled`,
}
